import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/components/Home/Home.component'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home
    }
  ],
  mode: 'history'
})



// WEBPACK FOOTER //
// ./src/router/index.js